/**
 *  Pobieranie listy odcinków i ćwiczeń
 *  Pobieranie danych dla samego ćwiczenia jest w exercises.js
 */

import { GET_COURSE_SECTIONS, GET_COURSE_SECTION, SHOW_SPINNER, HIDE_SPINNER, REFRESH_COURSE_SECTIONS, SHOW_NOTIFICATION } from '../types';
import api from '../../api';
import sessionErrHandler from './sessionErrHandler';
import { addCourseStats, setCurrentCourseId, setCurrentSectionId } from './index';

let timestamp = 0;
let lastUpdateTime = 0;

// Pobieranie listy odcinkow dla danego kursu
export const getCourseSections = (id) => async dispatch => {
  if (id === undefined) {
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: { message: 'Błąd aplikacji 500:2', type: 'error' }
    });
    return;
  }
  lastUpdateTime = getTimestamp();
  dispatch({ type: SHOW_SPINNER, payload: 'Pobieranie listy odcinków...'});
  const options = {
    method: 'get',
    url: `/course/element?courseId=${id}`,
    withCredentials: true
  }
  let response = {};
  try {
    response = await api(options);
  } catch (e) {
    sessionErrHandler(e, 'Błąd Pobierania listy ćwiczeń', dispatch);
  }
  dispatch({ type: HIDE_SPINNER });

  if (response.status === 200) {
    dispatch(addCourseStats(id, response.data));
    dispatch({ type: GET_COURSE_SECTIONS, sections: response.data });
    dispatch(setCurrentCourseId(id));
  }
}

// Pobieranie listy ćwiczeń dla danego odcinka
export const getCourseSection = (id, title, game = false) => async (dispatch) => {
  const time = getTimestamp();
  if (time - timestamp < 500) return console.log('Stopped, time: ' + (time - timestamp));
  timestamp = time;
  dispatch({ type: SHOW_SPINNER, payload: `Pobieram ${title}`});
  
  const options = {
    method: 'get',
    url: `/segment/${id}`,
    withCredentials: true
  }
  if (game) {
    options.url = `/course/gameSet/${id}`;
  }
  let response = {};
  try {
    response = await api(options);
  } catch (e) {
    sessionErrHandler(e, 'Błąd Pobierania ćwiczenia', dispatch);
  }
  dispatch({ type: HIDE_SPINNER });
  if (response.status === 200) {
    const parts = game ? response.data.map(g => { 
      return { ...g, elementType: 'GAME', id: `${g.id}:${g.type}` }
    }) : response.data;
    dispatch({ type: GET_COURSE_SECTION, section: { id, parts } });
    dispatch(setCurrentSectionId(id));
  }
}

function getTimestamp () {
  return new Date().getTime();
}

// Refresh sections - retrieves info about completed %
export const refreshCourseSections = () => async (dispatch, getState) => {
  if (getTimestamp() - lastUpdateTime < 10000) return;
  const state = getState();
  const id = state.userState.currentCourseId;
  if (id === undefined) {
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: { message: 'Błąd aplikacji 500:3', type: 'error' }
    });
    return;
  }
  lastUpdateTime = getTimestamp();
  const options = {
    method: 'get',
    url: `/course/element?courseId=${id}`,
    withCredentials: true
  }
  let response = {};
  try {
    response = await api(options);
  } catch (e) {
    // sessionErrHandler(e, 'Błąd Pobierania listy ćwiczeń', dispatch);
  }
  if (response.status === 200) {
    dispatch({ type: REFRESH_COURSE_SECTIONS, sections: response.data });
  }
}

// Refresh exercises - retrieves info about completion
export const refreshCourseSection = () => async (dispatch, getState) => {
  const time = getTimestamp();
  if (time - timestamp < 1500) return;
  timestamp = time;
  const state = getState();
  const id = state.userState.currentSectionId;
  const game = state.courseSections.find(section => section.id === id).game;
  const options = {
    method: 'get',
    url: `/segment/${id}`,
    withCredentials: true
  }
  if (game) {
    options.url = `/course/gameSet/${id}`;
  }
  let response = {};
  try {
    response = await api(options);
  } catch (e) {
    sessionErrHandler(e, 'Błąd Pobierania ćwiczenia', dispatch);
  }

  if (response.status === 200) {
    const parts = game ? response.data.map(g => { 
      return { ...g, elementType: 'GAME', id: `${g.id}:${g.type}` }
    }) : response.data;
    dispatch({ type: GET_COURSE_SECTION, section: { id, parts } });
  }
}